const Timer = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    className={className}
  >
    <path
      d="M7 2.5C7 2.22386 7.22386 2 7.5 2H11.5C11.7761 2 12 2.22386 12 2.5C12 2.77614 11.7761 3 11.5 3H7.5C7.22386 3 7 2.77614 7 2.5ZM14.4492 3.92899C14.6444 3.73373 14.961 3.73373 15.1563 3.92899L16.5705 5.34321C16.7658 5.53847 16.7658 5.85505 16.5705 6.05031C16.3752 6.24558 16.0587 6.24558 15.8634 6.05031L14.4492 4.6361C14.2539 4.44084 14.2539 4.12426 14.4492 3.92899ZM16.5 11C16.5 14.866 13.366 18 9.5 18C5.63401 18 2.5 14.866 2.5 11C2.5 7.13401 5.63401 4 9.5 4C13.366 4 16.5 7.13401 16.5 11ZM9 6.5V11.5C9 11.7761 9.22386 12 9.5 12C9.77614 12 10 11.7761 10 11.5V6.5C10 6.22386 9.77614 6 9.5 6C9.22386 6 9 6.22386 9 6.5Z"
      fill="currentColor"
    />
  </svg>
);

export default Timer;
